<div
  class="menu-list-wrapper"
  [class.submenus-list]="isSubmenu()"
>
  <div class="menu-item">
    @for (menuItem of menuList(); track $index) {
      @if (isMenuAvailableToCurrentUser(menuItem)) {
        @switch (menuItem.type) {
          @case ('default') {
            <app-default-left-menu-item
              [menu]="menuItem"
              [parentMenuId]="parentMenuId()"
              [(isMenuSmall)]="isMenuSmall"
            />
          }
          @case ('sub-menu') {
            <app-submenu-left-menu-item
              [menu]="menuItem"
              [parentMenuId]="parentMenuId()"
              [(isMenuSmall)]="isMenuSmall"
            />
          }
        }
      }
    }
  </div>
</div>
